import styled from 'styled-components';

const ButtonSpan = styled.span`
  padding: ${({ padding }) => padding || '10px 25px'};
  background: ${({ background }) => background || '#51ceaf'};
  color: ${({ color }) => color || '#fff'};
  opacity: 1;
  transition: all ease-in .15s;
  border-radius: 4px;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 600;

  :hover {
    box-shadow: 0 12px 30px rgba(0, 0, 0, .1);
  }
`;

export default ButtonSpan;